module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-iphone-retina-120x120-561afe79fbbcf56e7317101a2951e167.png";